import Home from '@/components/pages/home'

export default function MainPage() {
  return <Home />
}
